export default __webpack_public_path__ + "static/Marlene-McNeese-hero-mobile-bfefc0739f3db7bf57214e639bfb83ac.jpg";